import api from './api';

/**
* @returns {Promise<{
    *   items: {
    *     audio_id: string,
    *     transcript: string | null,
    *     created_at: string,
    *     updated_at: string
    *   }[],
    *   total: number,
    *   page: number,
    *   perPage: number,
    *   totalPages: number
    * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Assets-GetAudios
 */
    export default async function getAudioAssets({
        type,
        search,
        orderBy,
        order,
        page,
        perPage,
        version
      }) {
        const queryParams = new URLSearchParams();

        if (type) queryParams.append('audio_type', type);
        if (search) queryParams.append('audio_id', search);
        if (orderBy) queryParams.append('orderBy', orderBy);
        if (order) queryParams.append('order', order);
        if (page) queryParams.append('page', page);
        if (perPage) queryParams.append('perPage', perPage);
        if (version) queryParams.append('version', version);

        const { data } = await api.get(`assets/audios?${queryParams.toString()}`);
        return data;
      }